'use strict';

angular.module('mortgageController', ['ngSanitize'])
.controller('MortgageController', ['$scope', '$rootScope', '$log', '$location', '$window',
    function ($scope, $rootScope, $log, $location, $window ) {   

      $scope.pageTitle = "Mortgage Calculator"; 
      $rootScope.header.show = false;
      $scope.mortgage = {
        principal: "100000",
        rate: "0",
        term: "25",
        frequency: "12", //12, 26, 52
        type:  "pi",  //pi, io
        repaymentAmountText: ""
      }
      
      $scope.calculate = function()  {
          var i;
          var rsPeriod;
          var params = $scope.mortgage;

          if(params.rate == 0) {
            $scope.mortgage.repaymentAmountText = 'Please set proper interest rate.';
            return;
          }

          params.principal = params.principal.replace(/\$/g, "");
          params.principal = params.principal.replace(/\,/g, "");

          switch(params.frequency){
            case "12":
              rsPeriod = "per month";
              break;
            case "26":
              rsPeriod = "per fortnight";
              break;
            case "52":
              rsPeriod = "per week";
              break;
          }
         
          if(!(params.term>0 && params.term<100))  { 
              params.term = 25;  
          }

          var mi = eval(params.rate / (params.frequency*100));
          var base = 1;
          var mbase = 1 + mi;
          
          for (i=0; i<params.term * params.frequency; i++) {
            base *= mbase;
          }
          
          if (params.type == 'pi')  {
            var repaymentAmount = Math.floor(params.principal*mi / ( 1 - (1/base))*Math.pow(10,2))/Math.pow(10,2);
          } else {
            var repaymentAmount = Math.floor((params.principal*mi)*Math.pow(10,2))/Math.pow(10,2);
          }

          if (repaymentAmount>=0)  {
            var repayment= '$'+repaymentAmount.toFixed(2)+' (approx) '+rsPeriod;
            var response = '<p>Loans may be available from <i class="highlighted">'+repayment+'</i></p>';
            $scope.mortgage.repaymentAmountText = response;
          } else  {
            $scope.mortgage.repaymentAmountText = '';
          }
      }

      var init = function() {
        $scope.calculate(); 
      }

      init();

}]);